import { z } from 'zod';

export const FiatBankAccountsResultSchema = z.object({
  data: z.array(
    z.object({
      bank_name: z.string(),
      account_identifier_value: z.string(),
      supported_payment_networks: z.array(z.string()),
      currency: z.string(),
      created_at: z.string(),
      status: z.string(),
      bank_details: z.any(),
      id: z.string(),
      bank_identifier_value: z.string(),
    }),
  ),
});

export type FiatBankAccountsResult = z.infer<
  typeof FiatBankAccountsResultSchema
>;

export interface FiatBankAccountsParams {}
